var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M636.86 929.43l365.72-365.72a73.13 73.13 0 000-103.42L636.86 94.57A73.13 73.13 0 00533.44 198L774.3 438.86H73.14a73.14 73.14 0 000 146.28H774.3L533.44 826a73.13 73.13 0 00103.42 103.43z" } }] }, name: "arrow-right", theme: "outlined" };
export {
  a as default
};
